import { useMemo } from 'react'
import { useFeatureFlag } from '../../React/Common/Hooks/useFeatureFlag'
import { PermissionsUtil } from '../../React/Common/Utils/PermissionsUtil'
import { TelSysTypes } from '../../NonReact/constants/TelephonyServerTypes'
import { ReportingAccessLevels } from '../../NonReact/constants/Permissions'
import { IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
import { RxJSCurrentState, useRxJSState } from '../../React/Common/Hooks/useRxJSState'
import { currentUserState$ } from '../../NonReact/common/RxJS/UserInfoState'
import { AdminUserResponse } from '../../NonReact/common/Types/Types'

/**
 * A hook that determines whether the presence page is available to the user.
 */
export const useIsPresenceAvailable = (): Definable<boolean> => {
    const [userInfo]: RxJSCurrentState<AdminUserResponse> = useRxJSState(currentUserState$)

    const showPresencePageFlag: Definable<boolean> = useFeatureFlag('showTeamsPresencePage')

    return useMemo((): Definable<boolean> => {
        if (IsVarEmpty(userInfo) || IsVarEmpty(showPresencePageFlag)) {
            return undefined
        }

        if (showPresencePageFlag && !PermissionsUtil.isCMEWideUser(userInfo)) {
            const isMSTeamsTelSys: boolean = userInfo?.Scope?.TelSysTypes.includes(TelSysTypes.MS_TEAMS)
            const isReportingAccessValid: boolean =
                userInfo?.Scope?.ReportingAccess === ReportingAccessLevels.CXA_STANDARD ||
                userInfo?.Scope?.ReportingAccess === ReportingAccessLevels.CXA_ADVANCED_HISTORICAL ||
                userInfo?.Scope?.ReportingAccess === ReportingAccessLevels.CXA_ADVANCED ||
                userInfo?.Scope?.ReportingAccess === ReportingAccessLevels.CXA_PREMIUM

            return isMSTeamsTelSys && isReportingAccessValid && !userInfo.DisablePresenceBoard
        }

        return false
    }, [userInfo, showPresencePageFlag])
}
